import { Box, Typography } from "@mui/material";
import React from "react";

function ArticleCard({ data }) {
  return (
    <div
      style={{
        width: "320px",
        height: "500px",
        boxShadow: "-2rem 0 3rem -2rem #000",
        borderRadius: "20px",
        backdropFilter: "blur(10px)",
        overflow: "hidden",
        background: "linear-gradient(85deg,#434343,#262626)",
        display: "flex",
        flexDirection: "column",
        transition: ".2s",
        margin: 0,
        color: "#fff",
        textAlign: "start",
        padding: "20px",
        justifyContent: "end",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "480px",
          overflow: "hidden",
          borderRadius: "20px",
        }}
      >
        <img
          src={data.image}
          alt="article Image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
      <Box
        display={"flex"}
        height={"100%"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={"10px"}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "1.2rem", sm: "1.4rem" },
            fontWeight: 600,
            py: 1,
          }}
        >
          {data?.title}
        </Typography>
        <Typography
          variant="body2"
          style={{
            color: "rgba(255,255,255, 0.8)",
            fontSize: "1rem",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            // maxHeight: "5rem",
          }}
        >
          {data.description}
        </Typography>

        <a
          href={data.navigateTo}
          style={{
            textDecoration: "none",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            color: "#fff",
            padding: "8px",
            borderRadius: "10px",
            display: "flex",
            fontSize: "14px",
            width: "fit-content",
            // marginTop: "10px",
          }}
        >
          {" "}
          View Article{" "}
        </a>
      </Box>
    </div>
  );
}

export default ArticleCard;
